import { render, staticRenderFns } from "./Catalogues.vue?vue&type=template&id=d962d614"
import script from "./Catalogues.vue?vue&type=script&setup=true&lang=js"
export * from "./Catalogues.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports